import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';

import * as graphicOps from '../../../api/Graphics/graphic-operations';
import Graphics from '../../../api/Graphics/Graphics';
import * as layerOps from '../../../api/Layers/layer-operations';
import Layers from '../../../api/Layers/Layers';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import loadTableLayer from '../../../modules/load-table-layer';
import { GRAPH_ELEMENTS } from '../../../modules/graphic-elements';
import getGraphicProps from '../../../modules/get-graphic-props';

import PageHeader from '../../atoms/PageHeader';
import ShareColumn from '../../atoms/ShareColumn';

import Loading from '../../components/Loading';

class ViewGraphic extends Component {
  state = {
    aspectRatio: 1,
    attributes: [],
    height: window.innerHeight,
    // isCopied: false,
    values: [],
    width: window.innerWidth
  };

  async componentDidMount() {
    const { layer } = this.props;
    try {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
      const { tableBody, tableTitle } = await loadTableLayer(layer);
      this.setState({ attributes: tableTitle, values: tableBody });
    } catch (error) {
      Bert.alert(error.message, 'danger');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    let aspectRatio = 1;
    switch (true) {
      case window.innerWidth < 576:
        aspectRatio = 1;
        break;

      case window.innerWidth >= 576 && window.innerWidth < 768:
        aspectRatio = 8 / 12;
        break;

      case window.innerWidth >= 768:
        aspectRatio = 9 / 12;
        break;

      default:
        break;
    }
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
      aspectRatio
    });
  };

  handleRemove = async (graphicId, history, layerId) => {
    try {
      await methodPromise('graphics.softDelete', graphicId);
      Bert.alert('Graphic deleted!', 'warning');
      history.push(`/layers/${layerId}/graphics`);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleShared = async (graphicId, isShared) => {
    try {
      await methodPromise('graphics.toggleShared', graphicId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleSharedPrivate = async (graphicId, isShared) => {
    try {
      await methodPromise('graphics.toggleSharedPrivate', graphicId, !isShared);
      if (!isShared) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  render() {
    const { loading, graphic, history, match, layer } = this.props;
    const { attributes, values, height, width, /* isCopied, */ aspectRatio } = this.state;

    if (loading) return <Loading />;
    const { value } = GRAPH_ELEMENTS.properties[graphicOps.getType(graphic)];

    const graphicProps = getGraphicProps({
      width,
      height,
      graphic,
      attributes,
      values,
      aspectRatio
    });
    const previewWithProps = React.cloneElement(value, graphicProps);

    return (
      <>
        <PageHeader>
          <h4 className="mr-auto">{graphicOps.getName(graphic)}</h4>
          <ButtonGroup size="sm">
            <Button variant="outline-info" onClick={() => history.push(`${match.url}/edit`)}>
              Edit
            </Button>
            <Button
              onClick={() =>
                this.handleRemove(graphicOps.getId(graphic), history, layerOps.getId(layer))
              }
              variant="outline-danger"
            >
              Delete
            </Button>
          </ButtonGroup>
        </PageHeader>
        <Row noGutters>
          <ShareColumn
            toggleShared={() =>
              this.toggleShared(graphicOps.getId(graphic), graphicOps.isShared(graphic))
            }
            isShared={graphicOps.isShared(graphic)}
            sharedPath={`shared/graphics/${graphicOps.getPublicId(graphic)}`}
            toggleSharedPrivate={() =>
              this.toggleSharedPrivate(
                graphicOps.getId(graphic),
                graphicOps.isPrivateShared(graphic)
              )
            }
            isSharedPrivate={graphicOps.isPrivateShared(graphic)}
            sharedPathPrivate={`sharedPrivate/graphics/${graphicOps.getPublicId(graphic)}`}
          />
          <Col xs={12} sm={8} md={9}>
            {previewWithProps}
          </Col>
        </Row>
      </>
    );
  }
}

ViewGraphic.defaultProps = {
  graphic: {},
  layer: {}
};

ViewGraphic.propTypes = {
  graphic: PropTypes.object,
  layer: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withTracker(({ match, componentBool, layerID, graphicID }) => {
  if (componentBool) {
    const graphicId = graphicID;
    const layerId = layerID;
    const graphicSub = Meteor.subscribe('graphics');
    const layerSub = Meteor.subscribe('layers');

    return {
      loading: !layerSub.ready() || !graphicSub.ready(),
      graphic: Graphics.findOne(graphicId),
      layer: Layers.findOne(layerId)
    };
  }
  const graphicId = match.params.graphic_id;
  const layerId = match.params.layer_id;
  const graphicSub = Meteor.subscribe('graphics');
  const layerSub = Meteor.subscribe('layers');

  return {
    loading: !layerSub.ready() || !graphicSub.ready(),
    graphic: Graphics.findOne(graphicId),
    layer: Layers.findOne(layerId)
  };
})(ViewGraphic);
